import React from 'react'

const MatchHistorySearchHeader = () => (
    <>
        <p>
            Match History is a record of recent match suggestions that you&apos;ve made for unmatched recording groups.
            Once a match has been approved it will appear in the recording details section of the work within your
            catalog.
        </p>
    </>
)

export default MatchHistorySearchHeader
